'use client';
import { BaseTopNavigation } from '@repo/ui';
import { ReactNode, useState } from 'react';

import { BrandResourceLogoHeaderLeftButtons, LogoHeaderLeftButtons, LogoHeaderRightButtons, MobileMenu } from '@/app/_components/layout-content/HeaderItems';
import { LayoutContainerClassNames } from '@/lib/types/layout';

export const LogoHeader = () => {
  const [isOpenMobileMenu, setIsOpenMobileMenu] = useState(false);

  return (
    <header>
      <BaseTopNavigation
        className={'bg-white min-w-80 border-b border-b-neutral-border-main'}
        leftAction={<LogoHeaderLeftButtons />}
        rightAction={<LogoHeaderRightButtons isOpenMobileMenu={isOpenMobileMenu} setIsOpenMobileMenu={setIsOpenMobileMenu} />}
      />
      <MobileMenu isOpenMobileMenu={isOpenMobileMenu} />
    </header>
  );
};

export const BrandResourceLogoHeader = () => {
  return (
    <header>
      <BaseTopNavigation className={'bg-white min-w-80 border-b border-b-neutral-border-main'} leftAction={<BrandResourceLogoHeaderLeftButtons />} />
    </header>
  );
};

export const DefaultContainer = ({ children, className = '' }: { children: ReactNode; className?: string }) => {
  return <div className={`container container-large container-padding-large flex flex-col ${className}`}>{children}</div>;
};

export const MainContainer = ({ children, classNames }: { children: ReactNode; classNames?: LayoutContainerClassNames }) => {
  return <main className={`flex flex-col items-center flex-1 ${classNames?.main ?? ''}`}>{children}</main>;
};
